<template>
    <div class="view view__lms_superadmin_workspaces_edit">
        <lms-superadmin-workspace-edit/>
        <pop-notify
            ref="popNotify"
            :class="'pop__notify--redirect'"
            @emit-submit="redirect"
        />
    </div>
</template>

<script>
import LmsSuperadminWorkspaceEdit from '@/components/lms/superadmin/workspace/edit/LmsSuperadminWorkspaceEdit'
import PopNotify from '@/components/default/shared/PopNotify'
import { allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect } from '@/helpers/mixins'

export default {
  name: 'view-lms-superadmin-workspace-edit',
  components: { PopNotify, LmsSuperadminWorkspaceEdit },
  mixins: [allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect],
  computed: {
    routeWorkspaceId () {
      return this.$route.params.id
    }
  },
  methods: {
    getWorkspace () {
      this.$eventBus.$emit('start-loading')

      const workspaceId = this.$route.params.id
      this.$store.dispatch('lmsSuperadminWorkspaceGet', workspaceId).then(response => {
        const customerId = response.customerId
        this.$store.dispatch('lmsSuperadminCustomerGet', customerId).then(customerResponse => {
          const subscriptions = JSON.parse(JSON.stringify(customerResponse.subscriptions))
          const ssoSubscriptions = subscriptions.filter(obj => obj.serviceKey === 'SSO' && obj.status === 'active')
          const mappedSsoSubscriptions = ssoSubscriptions.map(obj => {
            return {
              name: obj.name,
              id: obj.id,
              active: false
            }
          })

          this.$store.dispatch('lmsSuperadminWorkspaceSetAuthSettings', mappedSsoSubscriptions)
          if (mappedSsoSubscriptions.length) {
            this.$store.dispatch('lmsSuperadminWorkspaceGetAuthSettings', workspaceId).finally(() => {
              this.$eventBus.$emit('stop-loading')
              this.$eventBus.$emit('view-lms-superadmin-workspace-edit-ready')
            })
          } else {
            this.$eventBus.$emit('stop-loading')
            this.$eventBus.$emit('view-lms-superadmin-workspace-edit-ready')
          }
        }).catch(() => {
          this.$eventBus.$emit('stop-loading')
          this.$eventBus.$emit('view-lms-superadmin-workspace-edit-ready')
        })
      }).catch(() => {
        this.$eventBus.$emit('stop-loading')
        this.$eventBus.$emit('view-lms-superadmin-workspace-edit-ready')
      })
    }
  },
  created () {
    this.getWorkspace()
  },
  mounted () {
    this.$eventBus.$on('workspace-submit', this.allowRedirect)
  },
  beforeDestroy () {
    this.$store.dispatch('lmsSuperadminWorkspaceReset')
    this.$eventBus.$off('workspace-submit')
  }
}
</script>
